import { Link } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import defaultImage from "../assets/img/logo.png";
import { productImageUrl, rememberMissingImage, hasKnownMissingImage } from "../utils/productImage";


// Si ya sabemos que este SKU no tiene foto, arrancamos con el placeholder y
// nos ahorramos el 404 (y el parpadeo) en cada render y en cada navegación.
const initialImageSrc = (sku) => hasKnownMissingImage(sku) ? defaultImage : productImageUrl(sku);

const ProductCard = ({ product, showPrice }) => {

	const [image, setImage] = useState(() => ({ sku: product.sku, src: initialImageSrc(product.sku) }));
	const imageRef = useRef(null);

	// La grilla reusa esta tarjeta para otro producto (al filtrar o buscar, la
	// lista cambia sin desmontarse), y ahí el nombre nuevo se quedaba con la foto
	// del anterior. El src se recalcula apenas cambia el SKU, sin esperar al efecto.
	if (image.sku !== product.sku) {
		setImage({ sku: product.sku, src: initialImageSrc(product.sku) });
	}

	const handleImageError = () => {
		rememberMissingImage(product.sku);
		setImage({ sku: product.sku, src: defaultImage });
	};

	// El HTML estático empieza a cargar la foto antes de hidratar, así que el
	// `onError` puede perderse: al montar (y al cambiar de SKU) revisamos si ya falló.
	useEffect(() => {
		const element = imageRef.current;
		if (element && element.complete && element.naturalWidth === 0) handleImageError();
	}, [product.sku]);

	return (
		<Link to={"/products/" + product.slug } className="group">
			<article className="flex h-72 flex-col items-center justify-between border border-line bg-white px-6 py-5 transition-all duration-300 group-hover:border-line-strong group-hover:shadow-card">
				<img
					ref={ imageRef }
					className="h-40 w-40 object-contain"
					src={ image.src }
					onError={ handleImageError }
					alt={ product.name }
					width="160"
					height="160"
					loading="lazy"
					decoding="async"
				/>

				<div className="mt-3 w-full text-center">
					<small className="text-[10px] font-semibold uppercase tracking-[.065em] text-muted">{ product.sku }</small>
					<h2 className="mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm text-ink-soft group-hover:whitespace-normal">
						{ product.name }
					</h2>
					{
						showPrice &&
							<p className="mt-1.5 overflow-hidden text-ellipsis whitespace-nowrap text-base font-bold tracking-[-.02em]">
								{
									product.price === 0 ? "AGOTADO" : "$ " + product.price
								}
							</p>
					}
				</div>
			</article>
		</Link>
	);
};

export default ProductCard;
